export const FIRST_RULE = `Mínimo de diez caracteres y longitud máxima
de 64, será de obligado cumplimiento el uso de caracteres alfanuméricos y especiales.`

export const SECOND_RULE = `Evitar caracteres
secuenciales y repetitivos (Ejemplo, “12345”, “123456789” o “aaaaaa”).`

export const THIRD_RULE = `Se reservarán un listado de palabras claves
relacionado con el contexto de la compañía para evitar su uso como parte de la contraseña
(Ejemplo: Nombre del producto, fabricante del equipo, empresa, etc.).`

export const FOUR_RULE = `Es necesario introducir al menos una mayúscula.`

export const TOP_LEVEL = 7
